"use client";

import React from "react";
import { MapPin, Phone, Mail, Terminal } from "lucide-react";
const contactNodes = [{
  id: "node-01",
  label: "HQ Coordinates",
  value: "40.7128° N, 74.0060° W",
  icon: MapPin,
  detail: "100 Aerospace Way, Tech District, NY 10001"
}, {
  id: "node-02",
  label: "Comms Channel",
  value: "+1 (800) 555-0199",
  icon: Phone,
  detail: "Available 24/7 for critical inquiries"
}, {
  id: "node-03",
  label: "Data Stream",
  value: "secure@aerospace-sys.com",
  icon: Mail,
  detail: "Encrypted transmission protocol active"
}];
export default function ContactUs() {
  return <section id="contact-us" className="bg-background py-24 relative overflow-hidden">
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes scan-line {
            0% { top: -10%; opacity: 0; }
            5% { opacity: 1; }
            95% { opacity: 1; }
            100% { top: 110%; opacity: 0; }
          }
          .animate-scan-line {
            animation: scan-line 5s linear infinite;
          }
        `
    }} />

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-stretch">
          
          

          <div className="lg:col-span-7 flex items-center">
            {}
          </div>

        </div>
      </div>
    </section>;
}